import React from 'react';
import {Button, Col, Form, Input, Modal, Row} from 'antd';
import {LockOutlined, UserOutlined} from '@ant-design/icons';
import useLogin from 'hooks/useLogin';

const LoginModal = ({ open, onCancel, onSuccess, onSignupClick }) => {
  const [form] = Form.useForm();
  const { login, loading } = useLogin({
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
      form.resetFields();
      if (onCancel) onCancel();
    }
  });

  const handleSubmit = async (values) => {
    try {
      await login(values);
    } catch (e) {
      // 에러 메시지는 useLogin에서 처리됩니다. 여기서는 예외 전파만 막습니다.
    }
  };

  const handleCancel = () => {
    form.resetFields();
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <Modal
      title="로그인"
      open={open}
      onCancel={handleCancel}
      footer={null}
      centered
      width={400}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          name="lgnUserNm"
          label="로그인사용자명"
          rules={[
            { required: true, message: '로그인사용자명을 입력해주세요.' }
          ]}
        >
          <Input
            prefix={<UserOutlined />}
            placeholder="로그인사용자명"
            size="large"
          />
        </Form.Item>

        <Form.Item
          name="pswd"
          label="비밀번호"
          rules={[
            { required: true, message: '비밀번호를 입력해주세요.' }
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="비밀번호"
            size="large"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            size="large"
            block
            style={{ marginBottom: '12px' }}
          >
            로그인
          </Button>
        </Form.Item>

        <Row justify="center">
          <Col>
            계정이 없으신가요?{' '}
            <Button
              type="link"
              onClick={onSignupClick}
              style={{ padding: 0 }}
            >
              회원가입
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default LoginModal;
